import { useState } from "react";

interface CheckboxGroupProps {
  label: string;
  name: string;
  options: string[];
  value?: string;
  onChange?: (name: string, value: string) => void;
  errors?: Record<string, string>;
  isDisabled?: boolean;
}

function CheckboxGroupInput({
  label,
  name,
  options,
  value = "",
  onChange,
  errors = {},
  isDisabled = false,
}: CheckboxGroupProps) {
  return (
    <div className="mb-4 pb-1 ">
      <div className="form-dark-text">{label}</div>
      {errors[name]?.length > 0 && (
        <p className=" text-danger ps-1 fs-12 pt-1 mb-1">{errors[name]}</p>
      )}
      <div className="checkbox-container mt-2">
        {options?.map((opt) => (
          <div className="form-check mb-1" key={opt}>
            <input
              className="form-check-input"
              type="checkbox"
              name={name}
              id={`${name}-${opt}`}
              value={opt}
              checked={value == opt}
              onChange={() => onChange?.(name, opt)}
              disabled={isDisabled}
            />
            <label className="form-check-label ps-2" htmlFor={`${name}-${opt}`}>
              {opt}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CheckboxGroupInput;
